import React from 'react';
import { Alert } from 'react-bootstrap';
import DangerSvgIcon from './../../../assets/svg/RedInfo.svg';
import SuccessSvgIcon from './../../../assets/svg/SuccessInfo.svg';
import WarningSvgIcon from './../../../assets/svg/warningInfo.svg';
import InfoSvgIcon from './../../../assets/svg/generalInfo.svg';
import GeneralSvgIcon from './../../../assets/svg_main/BlueInfo.svg';
import './InfoBars.css';

interface InfoBarProps {
  variant: 'success' | 'danger' | 'warning' | 'info' | 'general';
  message: string;
  className?: string;
}

const iconMap = {
  success: <SuccessSvgIcon className="info_bar_icon" />,
  danger: <DangerSvgIcon className="info_bar_icon" />,
  warning: <WarningSvgIcon className="info_bar_icon" />,
  info: <InfoSvgIcon className="info_bar_icon" />,
  general:<GeneralSvgIcon className="info_bar_icon"/>
};

const InfoBar: React.FC<InfoBarProps> = ({ variant, message, className }) => {
  return (
    <div className={`info_bar_main ${className}`}>
      <Alert className={`info_bar_custom_alert info_bar_custom-${variant}`}>
        {iconMap[variant]}
        <span className="info_bar">{message}</span>
      </Alert>
    </div>
  );
};

export default InfoBar;
